import React, { useEffect } from 'react';
import Logo from '../illustrations/Logo';

const LoadingScreen = ({ onComplete }) => {
  useEffect(() => {
    const timer = setTimeout(onComplete, 2000);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="fixed inset-0 bg-white z-50 flex items-center justify-center">
      <Logo className="text-black w-32 h-32" animate />
    </div>
  );
};

export default LoadingScreen;